export default "__VITE_ASSET__joi_PhYl__"